import { ReactNode } from "react";
import { FieldValues, Path, useFormContext } from "react-hook-form";

import { OptionType } from "@src/types";

import {
  StyledRadioButtonWrapper,
  StyledRequired,
} from "./FormRadioButtonGroup.style";
import { ErrorMessage } from "../ErrorMessage";
import { FormRadioButton } from "../FormRadioButton";

type FormRadioButtonGroupProps<FormData extends FieldValues> = {
  name: Path<FormData>;
  options: Array<OptionType>;
  errorMessage: ReactNode;
  label: ReactNode;
  onCBEChange?: (data: string) => void;
  horizontal?: boolean; // NEW OPTIONAL PROP
};

function FormRadioButtonGroup<FormData extends FieldValues>({
  name,
  options,
  errorMessage,
  label,
  onCBEChange,
  horizontal = false, // DEFAULT TO FALSE - keeps existing behavior
}: FormRadioButtonGroupProps<FormData>) {
  const {
    formState: { errors },
  } = useFormContext();

  return (
    <StyledRadioButtonWrapper data-testid="radioButtonGroup">
      <StyledRequired>{label}</StyledRequired>

      {/* CONDITIONAL WRAPPER */}
      {horizontal ? (
        // HORIZONTAL LAYOUT - only when horizontal={true}
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '15px',
          alignItems: 'center',
          marginTop: '8px'
        }}>
          {options.map((option, idx) => (
            <FormRadioButton
              key={idx}
              option={option}
              name={name}
              onChange={onCBEChange}
            />
          ))}
        </div>
      ) : (
        // VERTICAL LAYOUT - default behavior (existing)
        options.map((option, idx) => (
          <FormRadioButton
            key={idx}
            option={option}
            name={name}
            onChange={onCBEChange}
          />
        ))
      )}

      <ErrorMessage
        testId={`${name}-radioButtonGroup-input-error-message-required`}
        errorMessage={errors[name] ? errorMessage : null}
      />
    </StyledRadioButtonWrapper>
  );
}

export { FormRadioButtonGroup };
